import React from 'react';
import { useAdminApi } from './adminApi';
import DocumentsLibrary from '../documents/DocumentsLibrary';

function HandbookTab({ condo, notify }) {
  const api = useAdminApi();
  return <DocumentsLibrary api={api} base={`/api/admin/condos/${condo._id}/documents`} notify={notify} writing title="Handbook" />;
}

export default HandbookTab;
